import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { CountryPhoneCode } from '@campaign-portal/namespace/entities/countries/specs';
import { ExtendableRefBookService } from '@campaign-portal/components-library';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';

interface CountryPhoneCodeEntity extends CountryPhoneCode {
	id: number;
}

@Injectable({
	providedIn: 'root',
})
export class CountriesService extends ExtendableRefBookService<CountryPhoneCodeEntity> {
	constructor() {
		super();
	}

	override load(): Observable<ReadResponse<CountryPhoneCodeEntity[]>> {
		this.loading$.next(true);
		return from(
			fetch('./assets/data/country_codes.json')
				.then((response) => response.json())
				.then((resp: CountryPhoneCode[]) => {
					const result: ReadResponse<CountryPhoneCodeEntity[]> = {
						Total: resp.length,
						Success: true,
						Data: resp
							.filter((phoneCode) => phoneCode.code)
							.map((phoneCode) => ({ ...phoneCode, id: phoneCode.code }) as CountryPhoneCodeEntity),
					};
					return this.process(result);
				})
		);
	}

	override process(resp: ReadResponse<CountryPhoneCodeEntity[]>): ReadResponse<CountryPhoneCodeEntity[]> {
		this.list$.next(resp.Data);
		this.map$.next(
			this.list.reduce((result, item) => {
				result.set(item.code, item);
				return result;
			}, new Map())
		);
		this.loading$.next(false);
		return resp;
	}
}
